import SVSubscriptionExpiredNotice from '@apps/www/src/www/components/SVSubscriptionExpiredNotice';
import SVGridContainer from '@apps/www/src/www/containers/SVGridContainer';
import SVWithUserPage, {
	type Props as SVWithUserPageProps,
} from '@apps/www/src/www/containers/SVWithUserPage';
import useAuthSubscriptionIsExpired from '@apps/www/src/www/hooks/useAuthSubscriptionIsExpired';
import usePersistentSetting, {
	PersistentSettingKeys,
} from '@apps/www/src/www/hooks/usePersistentSetting';
import useUserAndBoardPageQuery from '@apps/www/src/www/hooks/useUserAndBoardPageQuery';
import UserItemsQuery from '@apps/www/src/www/queries/UserItemsQuery';
import usePaginatedQuery from '@pkgs/shared-client/hooks/usePaginatedQuery';
import FeedSourceType from '@pkgs/shared/enums/FeedSourceType';
import UpgradeButtonSource from '@pkgs/shared/enums/UpgradeButtonSource';

const _SVFeedUserItemsPage = ({ user }: SVWithUserPageProps) => {
	const [sortMethod] = usePersistentSetting(PersistentSettingKeys.ITEMS_SORT_METHOD);

	const { items, loading, paginate, isLimited } = usePaginatedQuery(UserItemsQuery, {
		variables: { username: user.username, sortMethod },
	});

	const expiredSubscriptionData = useAuthSubscriptionIsExpired();
	const { isOwner } = useUserAndBoardPageQuery();

	if (expiredSubscriptionData && !isOwner) {
		return (
			<SVSubscriptionExpiredNotice
				source={UpgradeButtonSource.BLOCKED_FEED_USER}
				expiredMessageType={expiredSubscriptionData.expiredMessageType}
			/>
		);
	}

	return (
		<SVGridContainer
			items={items}
			isLoading={loading}
			onPaginate={paginate}
			sourceType={FeedSourceType.USER}
			isLimited={isLimited}
		/>
	);
};

const SVFeedUserItemsPage = SVWithUserPage(_SVFeedUserItemsPage);

// @ts-ignore fix this
SVFeedUserItemsPage.withUserHeader = true;
// @ts-ignore fix this
SVFeedUserItemsPage.withUserSideMenu = true;

export default SVFeedUserItemsPage;
